'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./IconPopupSearch.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPopupSearch = function (_React$Component) {
    _inherits(IconPopupSearch, _React$Component);

    function IconPopupSearch(props) {
        _classCallCheck(this, IconPopupSearch);

        var _this = _possibleConstructorReturn(this, (IconPopupSearch.__proto__ || Object.getPrototypeOf(IconPopupSearch)).call(this, props));

        _this.state = {
            search: ''
        };

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(IconPopupSearch, [{
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
            this.setState({ search: '' });
            this.props.setMode({
                mode: this.state.search,
                id: this.props.selectedElements.first().get('id')
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            this.setState({ search: event.target.value });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'IconPopupSearch' },
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.handleSubmit },
                    _react2.default.createElement('input', { placeholder: 'Search icons...',
                        value: this.state.search,
                        onChange: this.handleChange })
                )
            );
        }
    }]);

    return IconPopupSearch;
}(_react2.default.Component);

exports.default = IconPopupSearch;


IconPopupSearch.propTypes = {
    setMode: _propTypes2.default.func,
    selectedElements: _propTypes2.default.object
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/modeMenu/IconPopupSearch.js
// module id = 2239
// module chunks = 0